import { __awaiter, __extends, __generator } from "tslib";
import { CartActions } from '../../actions/CartActions/CartActions';
import { SecondaryEvents, SPECS } from '../../constants';
import { BaseCurrentCartService, CurrentCartService, } from './CurrentCartService';
import { serialize, deserialize } from './serialize';
var origin = 'current-cart-service';
var SecondaryCurrentCartService = /** @class */ (function (_super) {
    __extends(SecondaryCurrentCartService, _super);
    function SecondaryCurrentCartService(props) {
        var _this = _super.call(this, props) || this;
        _this.promiseHandlers = {};
        _this.cartActions = new CartActions({
            siteStore: _this.siteStore,
            origin: origin,
            originatedInWorker: !_this.siteStore.experiments.enabled(SPECS.FixCCSInLightbox),
            context: props.context,
        }, _this.siteStore.experiments.enabled(SPECS.InitMainCCSFromSecondaryWhenNoMain) ? function () { return _this.refresh(); } : undefined);
        _this.waitForPrimaryReady = _this.siteStore.experiments.enabled(SPECS.InitMainCCSFromSecondaryWhenNoMain)
            ? _this.waitForPrimaryOrInit(props)
            : Promise.resolve();
        return _this;
    }
    SecondaryCurrentCartService.prototype.waitForPrimaryOrInit = function (props) {
        var _this = this;
        // eslint-disable-next-line prefer-const
        var ackEventSubscribeId;
        var resolve;
        var promise = new Promise(function (r) { return (resolve = r); });
        var timeoutId = setTimeout(function () {
            ackEventSubscribeId && _this.apis.pubSub.unsubscribe(SecondaryEvents.ACK, ackEventSubscribeId);
            var primaryCurrentCartService = new CurrentCartService(props);
            primaryCurrentCartService.init();
            resolve();
        }, 200);
        ackEventSubscribeId = this.apis.pubSub.subscribe(SecondaryEvents.ACK, function () {
            clearTimeout(timeoutId);
            _this.apis.pubSub.unsubscribe(SecondaryEvents.ACK, ackEventSubscribeId);
            resolve();
        }, false);
        this.apis.pubSub.publish(SecondaryEvents.HEALTH_CHECK, {}, false);
        return promise;
    };
    SecondaryCurrentCartService.prototype.init = function () {
        this.listenOnCacheChanges();
    };
    SecondaryCurrentCartService.prototype.getCurrentCart = function (options) {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.GetRequest, [options]);
    };
    SecondaryCurrentCartService.prototype.getCurrentCartGQL = function (options) {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.GetGQLRequest, [options]);
    };
    SecondaryCurrentCartService.prototype.estimateCurrentCartTotals = function (options) {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.EstimateCurrentCartTotals, [options]);
    };
    SecondaryCurrentCartService.prototype.refresh = function () {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.RefreshRequest);
    };
    SecondaryCurrentCartService.prototype.updateLineItemQuantity = function (options, biProps) {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.UpdateQuantityRequest, [options, biProps]);
    };
    SecondaryCurrentCartService.prototype.removeLineItem = function (options, biProps) {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.RemoveItemRequest, [options, biProps]);
    };
    SecondaryCurrentCartService.prototype.createCheckout = function (options) {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.CreateCheckoutRequest, [options]);
    };
    SecondaryCurrentCartService.prototype.updateBuyerNote = function (options) {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.UpdateBuyerNoteRequest, [options]);
    };
    SecondaryCurrentCartService.prototype.applyCoupon = function (options, biProps) {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.ApplyCouponRequest, [options, biProps]);
    };
    SecondaryCurrentCartService.prototype.removeCoupon = function (biProps) {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.RemoveCouponRequest, [biProps]);
    };
    SecondaryCurrentCartService.prototype.setAddress = function (options) {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.SetAddressRequest, [options]);
    };
    SecondaryCurrentCartService.prototype.selectShippingOption = function (options) {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.SelectShippingOptionRequest, [options]);
    };
    SecondaryCurrentCartService.prototype.addToCurrentCart = function (options) {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.AddToCurrentCart, [options]);
    };
    SecondaryCurrentCartService.prototype.listenOnCacheChanges = function () {
        var _this = this;
        this.apis.pubSub.subscribe(SecondaryEvents.ActionResponse, function (_a) {
            var _b, _c;
            var data = _a.data;
            var _d = deserialize(data), payload = _d.payload, key = _d.key, error = _d.error;
            /* istanbul ignore else */
            if (error) {
                (_b = _this.promiseHandlers[key]) === null || _b === void 0 ? void 0 : _b.reject(error);
            }
            else {
                (_c = _this.promiseHandlers[key]) === null || _c === void 0 ? void 0 : _c.resolve(payload);
            }
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete _this.promiseHandlers[key];
        }, false);
        this.apis.pubSub.subscribe(SecondaryEvents.Updated, function () {
            _this.runCallbacks();
        }, false);
    };
    SecondaryCurrentCartService.prototype.performActionOnMainCurrentCartService = function (event, payload) {
        if (payload === void 0) { payload = undefined; }
        return __awaiter(this, void 0, void 0, function () {
            var key, promise, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.waitForPrimaryReady];
                    case 1:
                        _a.sent();
                        key = generateRequestKey(event);
                        promise = new Promise(function (resolve, reject) { return (_this.promiseHandlers[key] = { resolve: resolve, reject: reject }); });
                        data = serialize({ key: key, payload: payload });
                        this.apis.pubSub.publish(event, data, false);
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    return SecondaryCurrentCartService;
}(BaseCurrentCartService));
export { SecondaryCurrentCartService };
var generateSecondaryCurrentCartGetRequestKey = function () {
    return "".concat(Date.now(), "-").concat(Math.random());
};
var generateRequestKey = function (prefix) {
    return "".concat(prefix, "-").concat(generateSecondaryCurrentCartGetRequestKey());
};
//# sourceMappingURL=SecondaryCurrentCartService.js.map